import { combineReducers } from "@reduxjs/toolkit";
import config from "./config";

const rootReducer = combineReducers({
  config,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
